module.exports = __webpack_public_path__ + "img/yml_gallery1.ee64c71a.jpg";